module.exports = __webpack_public_path__ + "static/Commune-Nuit_Debout_web-ee9960703c3137e51c5b47cf77e61d40.svg";